import { RocheUISocialMedia, RocheUISocialMediaAlignment } from '@repo/roche-ui';
import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import React, { FC, MouseEvent, useEffect, useState } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { useTranslation } from '../../hooks/use-translation';
import { AdobeTracking } from '../../tracking-services';
import { DefaultLinkClickData } from '../../tracking-services/types';

type RocheSocialMediaProps = BlokToComponentProps<{
  overline?: string;
  align?: RocheUISocialMediaAlignment;
  disable_facebook?: boolean;
  disable_twitter?: boolean;
  disable_linkedin?: boolean;
}>;

export const RocheSocialMedia: FC<RocheSocialMediaProps> = ({ blok }): JSX.Element => {
  const [url, setUrl] = useState<string | null>(null);
  const [mailToSubject, setMailToSubject] = useState<string | null>(null);
  const overline = blok.overline;
  const align = blok.align || RocheUISocialMediaAlignment.DEFAULT;
  const disableFacebook = blok.disable_facebook;
  const disableTwitter = blok.disable_twitter;
  const disableLinkedin = blok.disable_linkedin;
  const facebookLabel = useTranslation('facebook');
  const twitterLabel = useTranslation('twitter');
  const linkedinLabel = useTranslation('linkedin');
  const copylinkLabel = useTranslation('copy link');
  const copySuccessLabel = useTranslation('copy link success');

  useEffect(() => {
    if (!url) {
      const currentUrl = window.location.toString().split('#')[0];
      setUrl(currentUrl);
    }
    if (!mailToSubject) {
      setMailToSubject(document.title);
    }
  }, [url, mailToSubject]);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>, socialNetwork: string): void => {
    TrackingService.push({
      event: 'share',
      component_name: 'roche-social-media',
      additionalParameters: {
        social_network: socialNetwork,
        ...TrackingService.getParentAwareTrackingInfo(event.nativeEvent),
      },
    });

    const adobeTrackingData: DefaultLinkClickData = {
      innerText: '',
      url: (event.currentTarget as HTMLAnchorElement)?.href,
      position: 'RocheSocialMedia',
      type: 'Link',
      socialMedia: (event.currentTarget as HTMLAnchorElement)?.dataset.social,
      socialInteraction: 'Share',
    };

    AdobeTracking(adobeTrackingData, 'defaultLinkClick');
  };

  return (
    <RocheUISocialMedia
      overline={overline}
      align={align}
      facebookLabel={facebookLabel}
      twitterLabel={twitterLabel}
      linkedinLabel={linkedinLabel}
      copylinkLabel={copylinkLabel}
      disableFacebook={disableFacebook}
      disableTwitter={disableTwitter}
      disableLinkedin={disableLinkedin}
      mailToSubject={mailToSubject}
      url={url}
      onClick={handleClick}
      copySuccessLabel={copySuccessLabel}
    />
  );
};
